import { styled } from '@mui/material'

export const StyledContainerLoader = styled('div')`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.palette.grey[500]};
`
